<ng-container *ngIf="(uxInteractions$ | async) as uxInteractions" [formGroup]="fUser">
  <!--  <ng-container *ngIf="(currentUser$ | async) as currentUser">-->


  <div fxFlex fxLayout class="">
    <div fxFlex class="info-box p-8">
      Last logged: {{currentUser.lastLogged | date: 'short'}}
    </div>
    <div fxFlex class="info-box p-8 m-4">
      Created: {{currentUser.created | date: 'short'}}
    </div>
  </div>

  <div *ngIf="currentUser.type === 'client'" fxFlex class="p-8 mt-8">
    <app-url-placeholder [url]="getLoginUrl()"></app-url-placeholder>
  </div>

  <div fxFlex fxLayout *ngIf="currentUser.type === 'client'" class="p-8 mt-16">

    <ng-container *ngIf="(organizationList$ | async) as organizationList">

      <dx-select-box
        class="w-100-p"
        [dataSource]="organizationList"

        displayExpr="name"
        valueExpr="id"

        [searchMode]="'contains'"
        [searchExpr]="['id', 'name']"
        [searchTimeout]="200"
        [minSearchLength]="0"
        [searchEnabled]="true"

        formControlName="organizationId"

      >
      </dx-select-box>

    </ng-container>

  </div>


  <div fxFlex fxLayout>
    <mat-form-field fxFlex class="h-100-p p-8">
      <mat-label>Firstname</mat-label>
      <input matInput type="text" placeholder="Firstname...." formControlName="firstname">
    </mat-form-field>
    <mat-form-field fxFlex class="h-100-p p-8">
      <mat-label>Lastname</mat-label>
      <input matInput type="text" placeholder="Lastname...." formControlName="lastname">
    </mat-form-field>
  </div>

  <div fxFlex fxLayout>
    <mat-form-field fxFlex class="h-100-p p-8">
      <mat-label>Email</mat-label>
      <input matInput type="text" placeholder="Email...." formControlName="email">
    </mat-form-field>
  </div>

  <div fxFlex fxLayout class="mat-elevation-z2">
    <mat-form-field fxFlex class="h-100-p p-8">
      <mat-label>Change password</mat-label>
      <input matInput type="text" placeholder="Change password...." formControlName="newPassword">
    </mat-form-field>
  </div>

  <app-user-client-roles-selector
    *ngIf="currentUser.type === 'client'"
    class="mt-4"
    style="max-height: 350px;"
    [formControl]="fUser.get('userAccess')"
  >
  </app-user-client-roles-selector>

  <div
    fxFlex fxLayout fxLayoutAlign="end center" class="mt-8">

    <button
      mat-stroked-button class="mr-4 warn"
      [ladda]="disablingUser$|async"
      (click)="disableUser()"
    >Disable
    </button>

    <button
      [disabled]="fUser.pristine || !fUser.valid"
      mat-raised-button class="primary"
      [ladda]="updatingUser$|async"
      (click)="updateUser()"
    >Update
    </button>
  </div>

  <div *appIfDebugMode>
    <pre>{{fUser.getRawValue()|json}}</pre>
  </div>

  <span fxFlex="grow"></span>


  <!--  </ng-container>-->
</ng-container>
